import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { logoutAction } from '../../../actions/auth-actions';

/**
 * Logout hook
 * */

const useLogout = () => {
  const loading = useSelector(state => state.auth.logoutLoading);
  const dispatch = useDispatch();

  const logout = useCallback(opts => dispatch(logoutAction(opts)), [dispatch]);

  return {
    loading,
    logout,
  };
};

export default useLogout;
